// oxlint-disable jsx-key
import { FormattedMessage } from '@flipster/i18n';
import { Badge } from '@flipster/react/design-system/badge';
import { FastIconography } from '@flipster/react/graphic-assets/iconography/FastIconography';
import { InterfaceIconography } from '@flipster/react/graphic-assets/iconography/InterfaceIconography';
import { ProfitIconography } from '@flipster/react/graphic-assets/iconography/ProfitIconography';
import { TrendingIconography } from '@flipster/react/graphic-assets/iconography/TrendingIconography';
import { css } from '@flipster/styled-system/css';
import { flex, grid, hstack, stack } from '@flipster/styled-system/patterns';

export const Learn = () => {
  return (
    <section
      className={stack({
        gap: { tabletDown: 20, tablet: 24 },
        mt: 64,
      })}
    >
      <h2
        className={css({
          textStyle: 'Title/L',
          color: 'content.default.level-5',
        })}
      >
        <FormattedMessage id='Earn.r251204.How_dynamic_earn_works' />
      </h2>
      <div
        className={grid({
          columns: { base: 1, tablet: 2 },
          rowGap: { base: 10, tablet: 20 },
          columnGap: { base: 0, tablet: 20 },
        })}
      >
        <LearnCard
          iconography={<FastIconography />}
          title={<FormattedMessage id='Earn.r251204.Onchain_simple_feature_title' />}
          description={<FormattedMessage id='Earn.r251204.Onchain_simple_feature_desc' />}
          badges={[
            <FormattedMessage id='Earn.r251204.No_wallet_setup_benefit' />,
            <FormattedMessage id='Earn.r251204.No_bridging_benefit' />,
          ]}
        />
        <LearnCard
          iconography={<InterfaceIconography />}
          title={<FormattedMessage id='Earn.r251204.Trusted_curation_feature_title' />}
          description={<FormattedMessage id='Earn.r251204.Trusted_curation_feature_desc' />}
          badges={[
            <FormattedMessage id='Earn.r251216.Expert_picked_strategies' />,
            <FormattedMessage id='Earn.r251204.Trusted_strategy_partner_benefit' />,
          ]}
        />
        <LearnCard
          iconography={<TrendingIconography />}
          title={<FormattedMessage id='Earn.r251204.Earn_and_trade_feature_title' />}
          description={<FormattedMessage id='Earn.r251204.Earn_and_trade_feature_desc' />}
          badges={[<FormattedMessage id='Earn.r251204.Capital_efficiency_benefit' />]}
        />
        <LearnCard
          iconography={<ProfitIconography />}
          title={<FormattedMessage id='Earn.r251204.Redeem_anytime_feature_title' />}
          description={<FormattedMessage id='Earn.r260108.Redeem_anytime_feature_desc' />}
          badges={[]}
        />
      </div>
    </section>
  );
};

const LearnCard = ({
  iconography,
  title,
  description,
  badges,
}: {
  iconography: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
  badges: React.ReactNode[];
}) => {
  return (
    <div
      className={stack({
        gap: 20,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'border.default.level-1',
        rounded: 12,
        justify: 'space-between',
        p: { tabletDown: 16, tablet: 24 },
      })}
    >
      <div
        className={flex({
          tabletDown: { flexDirection: 'column', gap: 4, '& > svg': { w: 48, h: 48 } },
          tablet: { flexDirection: 'row', gap: 20, '& > svg': { w: 56, h: 56 } },
          '& > svg': { flexShrink: 0 },
        })}
      >
        {iconography}
        <div className={stack({ gap: 8 })}>
          <p className={css({ textStyle: 'Title/XS', color: 'content.default.level-5' })}>{title}</p>
          <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-2' })}>{description}</p>
        </div>
      </div>
      <div className={hstack({ gap: 4 })}>
        {badges.map((badge, index) => (
          <Badge key={index} type='tint' color='accent'>
            {badge}
          </Badge>
        ))}
      </div>
    </div>
  );
};
